import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="site-logo"
      className={`group inline-flex items-center gap-1.5 font-display font-black tracking-tighter text-2xl select-none ${className}`}
    >
      <span className="text-white">SITES</span>
      <span className="text-primary" style={{ textShadow: "0 0 22px rgba(59,130,246,0.5)" }}>
        UX
      </span>
    </Link>
  );
}
